module.exports = __webpack_public_path__ + "static/media/gallery_06.11536036.jpg";